export enum ServiceType {
	Import = 'Import',
	Enrichment = 'Enrichment',
	Calculation = 'Calculation',
	StatusWidget = 'StatusWidget',
	Common = 'Common',
	SignalR = 'SignalR',
}
